import instance from "./instance";

export const fetchInternshipExtensionEligibility = async (
  programID,
  companyID
) => {
  const params = { program_id: programID };
  if (companyID) params.company_id = companyID;
  const response = await instance.get("internship-extensions/eligibility/", {
    params,
  });
  return response.data;
};

export const fetchInternshipExtensions = async (params = {}) => {
  const response = await instance.get("internship-extensions/", { params });
  return response.data;
};

export const createInternshipExtension = async (payload) => {
  const response = await instance.post("internship-extensions/", payload);
  return response.data;
};

export const reviewInternshipExtension = async (id, payload) => {
  const response = await instance.patch(`internship-extensions/${id}/`, payload);
  return response.data;
};
